var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.725 7.30195V5.48633H10.9875V7.30195H3.725ZM3.725 14.5645V12.7488H9.17188V14.5645H3.725ZM3.725 10.9332V9.11758H10.9875V10.9332H3.725ZM0.09375 18.1957V1.85508H1.00156V0.947266H13.7109V1.85508H14.6187V6.39414H15.5266V7.30195H16.4344V8.20977H17.3422V9.11758H18.25V10.9332H17.3422V11.841H16.4344V12.7488H15.5266V13.6566H14.6187V18.1957H13.7109V19.1035H1.00156V18.1957H0.09375ZM1.90937 17.2879H12.8031V12.7488H13.7109V11.841H14.6187V10.9332H15.5266V9.11758H14.6187V8.20977H13.7109V7.30195H12.8031V2.76289H1.90937V17.2879Z",
    fill: "#737791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/get_started.1e07a6f10ff570f709ccc5667d6455f9.svg";
export { ForwardRef as ReactComponent };